import CustomTextArea from "components/Form/TeaxtAreaBootstrap";
import { UserRole } from "components/Reports/reportAssets/assets";
import { useRole } from "hooks/useRole";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

type noteProps = { control; errors; placeholder };

const RenderNoteToMainController = ({
  control,
  errors,
  placeholder,
}: noteProps) => {
  const { t } = useTranslation();
  const role = useRole();

  return (
    <Row className="text-area-decision-container default-vertical-padding">
      <Col>
        <CustomTextArea
          name="commentToSeniorController"
          control={control}
          label={t("commentToSeniorController")}
          rows={4}
          disabled={role === UserRole.SENIOR}
          errors={errors.commentToSeniorController}
          placeholder={placeholder}
          maxLength={240}
        />
      </Col>
    </Row>
  );
};

export default RenderNoteToMainController;
